import React, { Component } from 'react';
import { Card, CardHeader, CardBody, CardFooter, Label, FormGroup } from 'reactstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import { Row, Col, PageHeader, DatePicker, Input, Select, Table, Spin, Button, Tag, Modal } from 'antd';
import 'antd/dist/antd.css';
import { urlapi, token, CheckTokenExp } from '../../config';
import StatusType from '../Dropdown/StatusType';
import StatusSend from '../Dropdown/StatusSend';
import StatusFailover from '../Dropdown/StatusFailover';
import StatusSMS from '../Dropdown/StatusSMS';
import moment from 'moment';


class Log extends Component {
    constructor(props) {
        super(props);

        this.RequestJobInfo = this.RequestJobInfo.bind(this);
        this.onChangeinput = this.onChangeinput.bind(this);
        this.onChangedate = this.onChangedate.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
        this.export = this.export.bind(this);
        this.onSearch = this.onSearch.bind(this);

        this.state = {
            startDate: "",
            endDate: "",
            mobile: "",
            referCode: "",
            group1: "",
            group2: "",
            status: "",
            type: "",
            failover: "",
            statussms: 0,
            loglist: [],
            minpage: 1,
            pagesize: 10,
            current: 1,
            totalpage: 0,
            tableloading: false
        }
    }

    componentDidMount() {
        this.RequestJobInfo(1, this.state.pagesize);
    }

    //==== Request JobInfo ====
    RequestJobInfo(startdata, enddata) {
        if (!CheckTokenExp()) {
            this.setState({ tableloading: true })
            let req = JSON.stringify({
                start_date: this.state.startDate,
                end_date: this.state.endDate,
                mobile: this.state.mobile,
                refercode: this.state.referCode,
                groupcode1: this.state.group1,
                groupcode2: this.state.group2,
                status: this.state.status === "" ? 0 : this.state.status,
                startData: startdata,
                endData: enddata,
                failover: this.state.failover,
                statussms: this.state.statussms === "" ? 0 : this.state.statussms
            });

            fetch(urlapi + "api/requestReport", {
                method: 'post',
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Authorization": "Bearer " + token
                },
                body: req
            }).then(
                function (data) {
                    if (data.ok) {
                        data.json().then(
                            function (json) {
                                this.setState({ totalpage: json.totalpage, loglist: json.data });
                                this.setState({ currentpage: startdata == 1 ? 1 : this.state.currentpage });
                                this.setState({ tableloading: false });
                            }.bind(this)
                        );
                    } else {
                        this.setState({ tableloading: false });
                    }
                }.bind(this)
            ).catch(function () {
                this.setState({ tableloading: false });
                Modal.error({
                    content: 'Error on the internal server',
                });
            }.bind(this));
        } else {
            this.props.history.push("/logout");
        }

    }

    export() {
        if (!CheckTokenExp()) {
            let req = JSON.stringify({
                start_date: this.state.startDate,
                end_date: this.state.endDate,
                mobile: this.state.mobile,
                refercode: this.state.referCode,
                groupcode1: this.state.group1,
                groupcode2: this.state.group2,
                status: this.state.status,
                msgType: this.state.type
            });

            fetch(urlapi + "api/export/", {
                method: "POST",
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Authorization": "Bearer " + token
                },
                body: req
            }).then(response => response.blob())
                .then(blob => {
                    this.setState({ exportloading: false });
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = "Reportlog.xlsx";
                    document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                    a.click();
                    a.remove();  //afterwards we remove the element again         
                }).catch(function () {
                    this.setState({ tableloading: false });
                    Modal.error({
                        content: 'Error on the internal server',
                    });
                }.bind(this));
        } else {
            this.props.history.push("/logout");
        }


    }

    onChangePage(currentPage, pageSize) {
        var enddata = currentPage * pageSize;
        var startdata = ((currentPage * pageSize) + 1) - pageSize;
        this.setState({ currentpage: currentPage, pagesize: pageSize });

        this.RequestJobInfo(startdata, enddata)
    }

    onChangeinput(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    onChangedate(date, dateString) {
        this.setState({ startDate: dateString[0], endDate: dateString[1] });
    }

    onChangeSelect(value, e) {
        this.setState({ [e.props.name]: value });
    }

    onSearch() {
        this.RequestJobInfo(1, this.state.pagesize)
    }

    render() {
        const columns = [
            {
                title: 'Template ID',
                dataIndex: 'templateId',
                key: 'templateId',
                width: '20%',
            },
            {
                title: 'Template Name',
                dataIndex: 'templateName',
                key: 'templateName',
                width: '12%',
            },
            // {
            //     title: 'Type',
            //     dataIndex: 'messageType',
            //     key: 'messageType',
            //     width: '12%',
            // },
            {
                title: 'Reference Code',
                dataIndex: 'refercode',
                key: 'refercode',
                width: '12%',
            },
            {
                title: 'Group Code 1',
                dataIndex: 'modulecode1',
                key: 'modulecode1',
                width: '12%',
            },
            {
                title: 'Group Code 2',
                dataIndex: 'modulecode2',
                key: 'modulecode2',
                width: '12%',
            },
            {
                title: 'Mobile',
                dataIndex: 'phoneNumber',
                key: 'phoneNumber',
                width: '10%'
            },
            {
                title: 'Send Date',
                dataIndex: 'senddate',
                key: 'senddate',
                width: '12%',
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
                width: '5%',
                render: tags => (
                    <Tag style={{ textAlign: 'center' }}
                        className={
                            tags == "Delivered" ? "tag-delivered" :
                                tags == "Undelivered" ? "tag-reject" :
                                    tags == "Reject" ? "tag-undelivered" :
                                        tags == "Pending" ? "tag-pending" :
                                            tags == "Unverified" ? "tag-unverified" : ""
                        }>
                        {tags}
                    </Tag>
                ),
            },
            {
                title: 'Description',
                dataIndex: 'description',
                key: 'description',
                width: '10%',
            },
            {
                title: 'Failover Status',
                dataIndex: 'failoverstatus',
                key: 'failoverstatus',
                width: '10%',
            },
            {
                title: 'SMS Status',
                dataIndex: 'smsstatus',
                key: 'smsstatus',
                width: '10%',
            },
        ];
        const data = this.state.loglist;
        const { RangePicker } = DatePicker;
        const dateFormat = 'DD/MM/YYYY';
        const { Option } = Select;

        return (
            <div>
                <PageHeader title="Log">
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Row gutter={[16, 16]}>
                            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                                <Input placeholder="Mobile" name="mobile" onChange={this.onChangeinput} value={this.state.mobile} />
                            </Col>
                            {/* <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                <StatusType
                                    onchange={(e) =>
                                        this.setState({ type: e })
                                    }
                                />
                            </Col> */}

                            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                                <StatusSend
                                    onchange={(e) =>
                                        this.setState({ status: e })
                                    }
                                />
                            </Col>

                            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                                <Input placeholder="Reference Code" name="referCode" onChange={this.onChangeinput} value={this.state.referCode} />
                            </Col>
                            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                                <Input placeholder="Group Code1" name="group1" onChange={this.onChangeinput} value={this.state.group1} />
                            </Col>
                            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                                <Input placeholder="Group Code2" name="group2" onChange={this.onChangeinput} value={this.state.group2} />
                            </Col>
                            {/* </Row>

                        <Row gutter={[16, 16]}> */}
                            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                                <RangePicker
                                    style={{ width: "100%" }}
                                    format={dateFormat}
                                    suffixIcon={<span className="fa fa-calendar-o" />}
                                    onChange={this.onChangedate}
                                    ranges={{
                                        Today: [moment().startOf('day'), moment().endOf('day')],
                                        'Last 7 days': [moment().subtract(6, 'd'), moment()],
                                        'Last week': [moment().subtract(1, 'weeks').startOf('week'), moment().subtract(1, 'weeks').endOf('week')],
                                        'Last 15 days': [moment().subtract(14, 'd'), moment()],
                                        'Last 30 days': [moment().subtract(29, 'd'), moment()],
                                        'This month': [moment().startOf('month'), moment().endOf('month')]
                                    }}
                                />
                            </Col>

                            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                                <StatusFailover
                                    onchange={(e) =>
                                        this.setState({ failover: e })
                                    }
                                />
                            </Col>
                            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                                <StatusSMS
                                    onchange={(e) =>
                                        this.setState({ statussms: e })
                                    }
                                />
                            </Col>

                            <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                {/* <Row gutter={16} type="flex" justify="end">
                                    <Col xs={24} sm={24} md={24} lg={24} xl={6}></Col>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={8}></Col>
                                    <Col style={{ textAlign: 'right' }}> */}
                                <Button icon="search" style={{ width: '100%' }} onClick={this.onSearch}>
                                    Search
                                </Button>
                                {/* </Col>
                                </Row> */}

                            </Col>
                        </Row>
                    </Col>
                </PageHeader>

                <div className="content">
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Spin spinning={this.state.tableloading}>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col xs="12" sm="12" md="12" lg="12">
                                            <Table
                                                rowKey={key => key.ID}
                                                style={{ whiteSpace: 'pre' }}
                                                pagination={{
                                                    current: this.state.currentpage,
                                                    defaultPageSize: "10",
                                                    pageSizeOptions: ['10', '20', '50'],
                                                    showSizeChanger: true,
                                                    total: this.state.totalpage,
                                                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${this.state.totalpage} items`,
                                                    onShowSizeChange: (currentPage, pageSize) => this.onChangePage(currentPage, pageSize),
                                                    onChange: (currentPage, pageSize) => this.onChangePage(currentPage, pageSize)
                                                }}
                                                columns={columns}
                                                dataSource={data}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Spin>
                    </Col>
                </div>
            </div>
        );
    }
}

export default Log;



// WEBPACK FOOTER //
// ./src/views/Log/Log.js